import React, { useState } from 'react'
import { TextField, InputAdornment } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import MobilePicker, { type MobilePickerOption } from './MobilePicker'

interface PickerFieldProps {
  label: string
  required?: boolean
  value: string
  options: MobilePickerOption[]
  onChange: (value: string) => void
  placeholder?: string
  disabled?: boolean
  error?: boolean
  helperText?: string
  clearLabel?: string
  /** 顯示文字若指定則覆寫預設「找 option.label」邏輯（如雙語/姓名+ID） */
  displayValue?: string
}

/**
 * 卡片式選擇欄位 — 點下開啟 MobilePicker 全螢幕大按鈕選擇器。
 *
 * 外觀對齊 MUI outlined TextField：label 嵌在邊框缺口，與表單其他 TextField 一致。
 */
const PickerField: React.FC<PickerFieldProps> = ({
  label, required, value, options, onChange, placeholder = '請選擇',
  disabled, error, helperText, clearLabel, displayValue,
}) => {
  const [open, setOpen] = useState(false)
  const selectedLabel = displayValue ?? (options.find((o) => o.value === value)?.label ?? '')

  return (
    <>
      <TextField
        label={label}
        required={required}
        value={selectedLabel}
        placeholder={placeholder}
        disabled={disabled}
        error={error}
        helperText={helperText}
        fullWidth
        onClick={() => !disabled && setOpen(true)}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <ChevronRightIcon sx={{ color: '#999' }} />
            </InputAdornment>
          ),
          sx: {
            cursor: disabled ? 'default' : 'pointer',
            backgroundColor: disabled ? '#f5f5f5' : 'white',
            '& input': { cursor: disabled ? 'default' : 'pointer' },
          },
        }}
      />
      <MobilePicker
        open={open}
        title={label}
        options={options}
        value={value}
        onChange={onChange}
        onClose={() => setOpen(false)}
        clearLabel={clearLabel}
      />
    </>
  )
}

export default PickerField
